module.exports = __webpack_public_path__ + "static/19-544dac57ed085ce2133eac10dd5ab353.jpg";